import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="border-t border-[#EBE8DF] bg-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo height={48} />
          <p className="mt-6 text-[#5C5C5C] max-w-sm leading-relaxed">
            Simple, beautiful, high-converting custom websites — built for small businesses and tuned for AI search.
          </p>
          <p className="mt-6 text-xs label-eyebrow">AI-Powered Solutions · Human Touch</p>
        </div>

        <div className="md:col-span-2">
          <p className="label-eyebrow mb-4">Company</p>
          <ul className="space-y-3 text-[15px]">
            <li><a href="#concepts" className="ulink">Concepts</a></li>
            <li><Link to="/framework" className="ulink">Framework</Link></li>
            <li><Link to="/ai-search" className="ulink">AI Search</Link></li>
            <li><Link to="/pricing" className="ulink">Get a Quote</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="label-eyebrow mb-4">Access</p>
          <ul className="space-y-3 text-[15px]">
            <li><Link to="/portal/login" className="ulink">Client Portal</Link></li>
            <li><Link to="/admin/login" className="ulink">Admin</Link></li>
            <li><a href="#contact" className="ulink">Contact</a></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="label-eyebrow mb-4">Get in touch</p>
          <p className="text-[15px]"><a href="mailto:hello@shumwaytech.com" className="ulink">hello@shumwaytech.com</a></p>
          <p className="text-[15px] mt-2 text-[#5C5C5C]">Mon–Fri · 9a–6p CT</p>
        </div>
      </div>

      <div className="border-t border-[#EBE8DF]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row md:justify-between gap-2 text-xs text-[#8B8C89]">
          <p>© {new Date().getFullYear()} Shumway Tech. All rights reserved.</p>
          <p>Built with care · Designed to convert</p>
        </div>
      </div>
    </footer>
  );
}
